export default class PracticeExamsShow {
    constructor() {
        this.final_note_url = document.getElementById('final_note').getAttribute('data-final-note-url');
        this.finished = document.getElementById('final_note').getAttribute('data-finished')== 'true';
        this.bindEvents();
        // Initialize page content visibility based on selected exam place
        this.updateContentVisibility();
        // Initialize image upload functionality
        this.initCommentImageHandling();
        this.initImageZoom();
    }

    bindEvents() {
        const placeSelect = document.getElementById('select-exam-place');
        if (placeSelect) {
            $(placeSelect).select2({
                theme: "bootstrap",
                width: "100%",
                dropdownParent: $(".exam-place-select"),
                minimumInputLength: -1,
                tags: true, // Allow creating new tags
                createTag: function(params) {
                    return {
                        id: params.term,
                        text: params.term,
                        newTag: true
                    };
                },
                placeholder: "Choisir un centre d'examen"
            }).on('change', (e) => {
                this.handlePlaceChange(e);
                this.updateContentVisibility();
            }).on("select2:open", () => {
                document.querySelector(".select2-container--open .select2-search__field").focus()
            })


            //placeSelect.addEventListener('change', this.handlePlaceChange.bind(this));
        }

        this.handleSkillNoteButtons();
        this.checkIfFinished();
    }

    updateContentVisibility() {
        const $placeSelect = $('#select-exam-place');
        const $pageContent = $('#practice-exam-content');
        
        if ($placeSelect.length && $pageContent.length) {
            if (!$placeSelect.val()) {
                $pageContent.addClass('d-none');
            } else {
                $pageContent.removeClass('d-none');
            }
        }
    }

    handleSkillNoteButtons() {
        var self = this;
        document.querySelectorAll('.practice-exam-skill-note-button:not(.disabled)').forEach((button) => {
            button.addEventListener('click', () => {
                const status = button.getAttribute('data-status');
                const skillItem = button.closest('.practice-exam-skill-item');
                console.log(skillItem);
                const practiceExamId = skillItem.getAttribute('data-practice-exam-id');
                const noteId = skillItem.getAttribute('data-note-id');
                const customerId = skillItem.getAttribute('data-customer-id');
        
                // Désactiver tous les boutons du même skill-item
                skillItem.querySelectorAll('.practice-exam-skill-note-button').forEach((btn) => {
                btn.classList.add('readonly');
                btn.style.pointerEvents = 'none';
                });
        
                fetch(`/monitor/students/${customerId}/booklet/practice_exams/${practiceExamId}/note/${noteId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({ note: status })
                }).then(response => response.json()).then(data => {
                if (data.success) {
                    self.finished = data.finished;
                    skillItem.querySelectorAll('.practice-exam-skill-note-button').forEach((btn) => {
                    btn.classList.remove('selected');
                    });
                    button.classList.add('selected');
                }
                }).finally(() => {
                    // Réactiver tous les boutons du même skill
                    skillItem.querySelectorAll('.practice-exam-skill-note-button').forEach((btn) => {
                        btn.classList.remove('readonly');
                        btn.style.pointerEvents = 'auto';
                    });

                    // Mettre à jour la note finale
                    self.updateFinalNotePart();
                });
            });
        });
    }

    checkIfFinished() {
        if (this.finished) {
            // Disable skill note buttons
            document.querySelectorAll('.practice-exam-skill-note-button').forEach((btn) => {
                btn.classList.add('readonly');
                btn.style.pointerEvents = 'none';
            });
            
            // Disable select2
            const placeSelect = document.getElementById('select-exam-place');
            if (placeSelect) {
                $(placeSelect).prop('disabled', true);
                $(placeSelect).select2('destroy');
                $(placeSelect).select2({
                    theme: "bootstrap",
                    width: "100%", 
                    dropdownParent: $(".exam-place-select"),
                    disabled: true
                });
            }
        }
    }

    updateFinalNotePart() {
        const finalNoteContainer = document.getElementById('final_note');
        if (finalNoteContainer) {
            fetch(this.final_note_url)
                .then(response => response.text())
                .then(data => {
                    finalNoteContainer.innerHTML = data;
                });
        }
    }
    
    handlePlaceChange(e) {
        const placeSelect = e.target;
        const examId = placeSelect.dataset.examId;
        const studentId = placeSelect.dataset.studentId;
        const refreshIcon = document.getElementById('refresh-icon');
        
        if (refreshIcon) {
            refreshIcon.classList.remove('d-none');
        }

        fetch(`/monitor/students/${studentId}/booklet/practice_exams/${examId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
            },
            body: JSON.stringify({
                practice_exam: {
                    exam_place_name: placeSelect.value
                }
            })
        })
        .then(response => response.json())
        .then(() => {
            if (refreshIcon) {
                refreshIcon.classList.add('d-none');
            }
        })
        .catch(error => {
            console.error('Error:', error);
            if (refreshIcon) {
                refreshIcon.classList.add('d-none');
            }
        });
    }

    initCommentImageHandling() {
        // Import the ImageHandler utility
        import('../utils/ImageHandler').then(module => {
            const ImageHandler = module.default;
            // Create an instance of the image handler utility
            this.imageHandler = new ImageHandler();
            // Initialize all image handling functionality
            this.imageHandler.initializeImageHandling();
        });
    }

    initImageZoom() {
        // Import the ImageZoom utility
        import('../utils/ImageZoom').then(module => {
            const ImageZoom = module.default;
            // Create an instance of the image zoom utility
            this.imageZoom = new ImageZoom();
        });
    }

    updateImageButtonStyle(commentId) {
        const container = document.getElementById(`image-container-${commentId}`);
        if (!container) return;
        
        // Count visible image containers (excluding the add button containers)
        const imageCount = container.querySelectorAll('.comment-image-container:not(.image-add-plus):not(.removed)').length;
        
        // Get the button elements
        const textLinkBtn = document.getElementById(`image-add-link-${commentId}`);
        const plusIconBtn = document.getElementById(`image-add-plus-${commentId}`);
        
        if (imageCount === 0) {
            // No images, show text link button, hide plus icon
            if (textLinkBtn) textLinkBtn.classList.remove('d-none');
            if (plusIconBtn) plusIconBtn.classList.add('d-none');
        } else {
            // Has images, show plus icon, hide text link
            if (textLinkBtn) textLinkBtn.classList.add('d-none');
            if (plusIconBtn) plusIconBtn.classList.remove('d-none');
        }
    }
}